import type { NavigationGuardNext } from 'vue-router';
import { OrganizationRights } from '@/clients/v1';
import { useOrganizationsStore } from '@/stores/v2/OrganizationStore.ts';

import { hasOrganizationRights } from '@/composables/Auth.ts';
import { useFlagsAccess } from '@/composables/Flags.ts';

export const validateRiskManagementAccess = (next: NavigationGuardNext) => {
  const organizationsStore = useOrganizationsStore();

  if (
    organizationsStore.riskManagementEnabled &&
    hasOrganizationRights(OrganizationRights.OrganizationsRiskRead)
  ) {
    next();
  } else {
    next({ name: 'home' });
  }
};

export const validateGovernanceAccess = (next: NavigationGuardNext) => {
  const organizationsStore = useOrganizationsStore();

  if (organizationsStore.governanceEnabled) {
    next();
  } else {
    next({ name: 'home' });
  }
};

export const validateUserAccess = async (next: NavigationGuardNext) => {
  const { haveUserAccess } = useFlagsAccess();

  if (haveUserAccess.value) {
    next();
  } else {
    next({ name: 'home' });
  }
};

export const validateConfigAccess = async (next: NavigationGuardNext) => {
  if (hasOrganizationRights(OrganizationRights.OrganizationsConfigRead)) {
    next();
  } else {
    next({ name: 'home' });
  }
};

export const validateConfigUpdateAccess = async (next: NavigationGuardNext) => {
  if (hasOrganizationRights(OrganizationRights.OrganizationsConfigUpdate)) {
    next();
  } else {
    next({ name: 'home' });
  }
};

export const validatePolicyAccess = async (next: NavigationGuardNext) => {
  if (hasOrganizationRights(OrganizationRights.OrganizationsPolicyRead)) {
    next();
  } else {
    next({ name: 'home' });
  }
};

export const validatePolicyManagementAccess = async (next: NavigationGuardNext) => {
  if (hasOrganizationRights(OrganizationRights.OrganizationsPolicyEdit)) {
    next();
  } else {
    next({ name: 'policies-my-policies' });
  }
};
